import { forwardRef } from "react";
import SceneFrame from "./SceneFrame";
import { getSceneImageProps } from "../sceneAssets";

const Scene4 = forwardRef(function Scene4({ copy, language, isArabic, breakpoint = "desktop" }, ref) {
  const { imageSrc, imageSrcSet, imageSizes } = getSceneImageProps(4, breakpoint);
  return (
    <SceneFrame
      ref={ref}
      sceneId={4}
      imageSrc={imageSrc}
      imageSrcSet={imageSrcSet}
      imageSizes={imageSizes}
      copy={copy}
      language={language}
      isArabic={isArabic}
    />
  );
});

export default Scene4;
